import script from "./SecurityUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityUserForm.vue?vue&type=script&setup=true&lang=js"

import "./SecurityUserForm.vue?vue&type=style&index=0&id=12efad68&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12efad68"]])

export default __exports__